(function (angular) {
    'use strict';

    angular.module('shared')
        .component('dateRangePicker', {
            bindings: {
                initialDateRange: "=",
                onChange: "&"
            },
            controller: ["$rootScope",
                function ($rootScope) {

                    var ctrl = this;

                    /**
                     * 
                     */
                    ctrl.$onInit = function () {

                        ctrl.calendar = {
                            range: {
                                to: {},
                                from: {}
                            }
                        };

                        ctrl.range = {};

                        ctrl.fromOptions = {
                            // minDate: new Date()
                            showWeeks: false
                        };

                        ctrl.toOptions = {
                            // minDate: new Date()
                            showWeeks: false
                        };

                        ctrl.selectedDateRange = ctrl.initialDateRange || "7Days";

                        // the two text inputs
                        ctrl.rangeFrom = undefined;
                        ctrl.rangeTo = undefined;

                        ctrl.setDateRange(ctrl.selectedDateRange);
                    }

                    ctrl.open = function ($event, toOpen) {
                        $event.preventDefault();
                        $event.stopPropagation();
                        toOpen.opened = !toOpen.opened;
                    };

                    ctrl.selectedDateRangeChanged = function () {
                        ctrl.setDateRange(ctrl.selectedDateRange);
                    }

                    ctrl.fromChanged = function () {
                        ctrl.selectedDateRange = undefined;

                        // make sure to cant be less than from
                        ctrl.toOptions.minDate = new Date(ctrl.rangeFrom);

                        ctrl.publishChange();
                    }

                    ctrl.toChanged = function () {
                        ctrl.selectedDateRange = undefined;

                        // make sure to cant be less than from
                        ctrl.fromOptions.maxDate = new Date(ctrl.rangeTo);

                        ctrl.publishChange();
                    }

                    ctrl.setDateRange = function (selectedDateRange) {
                        switch (selectedDateRange) {
                            case "Today":
                                ctrl.rangeFrom = moment().startOf('day').toDate();
                                ctrl.rangeTo = moment().endOf('day').toDate();
                                break;
                            case "7Days":
                                ctrl.rangeFrom = moment().startOf('week').toDate();
                                ctrl.rangeTo = moment().endOf('week').toDate();
                                break;
                            case "30Days":
                                ctrl.rangeFrom = moment().startOf('month').toDate();
                                ctrl.rangeTo = moment().endOf('month').toDate();
                                break;
                        }

                        ctrl.publishChange();
                    }

                    ctrl.publishChange = function () {
                        if (ctrl.onChange) {
                            ctrl.onChange({ from: ctrl.rangeFrom.toISOString(), to: ctrl.rangeTo.toISOString() });
                        }
                    }


                }],
            templateUrl: 'shared/dateRangePicker/dateRangePicker.html'

        })

})(window.angular);